import { render, staticRenderFns } from "./affiliateWithdrawalManage.vue?vue&type=template&id=4d42ec58&scoped=true"
import script from "./affiliateWithdrawalManage.vue?vue&type=script&lang=js"
export * from "./affiliateWithdrawalManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateWithdrawalManage.vue?vue&type=style&index=0&id=4d42ec58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d42ec58",
  null
  
)

export default component.exports